module.exports = __webpack_public_path__ + "static/media/Logo_12week_UPTO_1asterisk_fr.0c76e296.svg";